import type {FieldOfArea} from '../sanity/complaint-guide/constants';

/**
 * Resolve a single field from the variant matching the active field of area,
 * falling back to a default when there is no active area, no variants, or the
 * matching variant does not override that field.
 *
 * Generic over the variant type so call sites need no casts: the field key and
 * the returned value are both inferred from the variant array that is passed.
 */
export function resolveVariant<
	V extends {fieldOfArea: FieldOfArea},
	K extends keyof V,
	D,
>(
	activeFieldOfArea: FieldOfArea | null,
	variants: V[] | undefined,
	field: K,
	defaultValue: D,
): NonNullable<V[K]> | D {
	if (!activeFieldOfArea || !variants) {
		return defaultValue;
	}
	const variant = variants.find((v) => v.fieldOfArea === activeFieldOfArea);
	return variant?.[field] ?? defaultValue;
}
